export default {"src":"/_next/static/media/placeholder-product-gray.1634b089.svg","height":1110,"width":1110};